var newsletter = {
    newsletterMsg: "We noticed that this email has already subscribed or has an existing account with us. Please Sign In to update your newsletter subscription or Contact Us."
}
/********************************** INFO API ********************************/
var shop_api = 'https://clarks-singapore.myshopify.com';

var shop_api_url = shop_api + '/';


var requestUrl = 'https://36c24c23ba08ccf719d3b86d0e2942c0:9dc157967fb8c2d94f25e5a7d6521bb5@clarks-singapore.myshopify.com/admin/api/2019-07/';
var reqUrlNoAuth = shop_api + '/admin/api/2019-07/';
if(shop_url != shop_api ){
    var reqUrlNoAuth = 'https://cors-anywhere.herokuapp.com/'+ shop_api +'/admin/api/2019-07/';
}
var auth = "Basic MzZjMjRjMjNiYTA4Y2NmNzE5ZDNiODZkMGUyOTQyYzA6OWRjMTU3OTY3ZmI4YzJkOTRmMjVlNWE3ZDY1MjFiYjU=";

/*********************** NEWSLETTER FORM (Not Login) ********************************/

$("#newsletter-form-not-logged .contact-form").submit(function(e) {
    e.preventDefault();
}).validate({
    rules: {
        agree: "required",
        "contact[email]": {
            required: true,
            email: true
        }
    },
    messages: {
        agree: "Please accept our policy"
    },
    submitHandler: function(form) {
        var women = $('#womens_m');
        var men =  $('#mens_m');
        var notes = '';
        if(women.prop('checked')){
            if(notes == ''){
                notes += women.val();
            }else{
                notes += ',';
                notes += women.val();
            }
        }
        if(men.prop('checked')){
            if(notes == ''){
                notes += men.val();
            }else{
                notes += ',';
                notes += men.val();
            }
        }
        $('#gender_sub').val(notes);


        var email = $('#newsletter_form_id_m .newsletter__input').val();

        var request = new XMLHttpRequest();

        var resUrl = reqUrlNoAuth + 'customers/search.json?query=email:' + email ;
        

        request.open("GET", resUrl ,false );

        request.setRequestHeader("authorization", auth );
                
        request.setRequestHeader("Content-Type", "application/json");

        request.onload = function() { 

            if (request.status >= 200 && request.status < 300) {
                var isMember = false;
                var response = jQuery.parseJSON(request.response);
                var customers = response.customers;
                if(customers.length > 0){
                    isMember = true;
                }
                if(isMember){
                    $('#msg-m').html(newsletter.newsletterMsg);
                    $('#msg-m').addClass('errors');
                }else{
                    $('#msg-m').removeClass('errors').html('');
                    form.submit();
                }
            }


        };
        request.send();
    }
});


$("#frmSubscribeClarksEmails").submit(function(e) {
    e.preventDefault();
}).validate({
    rules: {
        "subscribeToEmail": {
            required: true,
            email: true
        }
    },
    submitHandler: function(form) {

        var email = $('#subscribeToEmail').val();

        var request = new XMLHttpRequest();

        var resUrl = reqUrlNoAuth + 'customers/search.json?query=email:' + email ;
    

        request.open("GET", resUrl ,false );

        request.setRequestHeader("authorization", auth );
                
        request.setRequestHeader("Content-Type", "application/json");

        request.onload = function() { 

            if (request.status >= 200 && request.status < 300) {
                var isMember = false;
                var response = jQuery.parseJSON(request.response);
                var customers = response.customers;
                if(customers.length > 0){
                    isMember = true;
                }
                if(isMember){
                    $('#msg').html(newsletter.newsletterMsg);
                    $('#msg').addClass('errors');
                }else{
                    $('#msg').removeClass('errors').html('');
                    $('.sticky-email-box').hide();
                    $('#news-form').show();
                    $('#news-form input.newsletter__input').val(email);
                }
            }


        };
        request.send();
    }
});
$("#news-form .contact-form").submit(function(e) {
    e.preventDefault();
}).validate({
    rules: {
        agree: "required"
    },
    messages: {
        agree: "Please accept our policy"
    },
    submitHandler: function(form) {
        var women = $('#womens_f');
        var men =  $('#mens_f');
        var notes = '';
        if(women.prop('checked')){
            if(notes == ''){
                notes += women.val();
            }else{
                notes += ',';
                notes += women.val();
            }
        }
        if(men.prop('checked')){
            if(notes == ''){
                notes += men.val();
            }else{
                notes += ',';
                notes += men.val();
            }
        }
        $('#gender_sub_f').val(notes); 
        form.submit();
    }
});
if(typeof $("#news-form .note--success").html() !== 'undefined'){
    $('#msg').html($("#news-form .note--success").html());
    $('#msg').addClass('note');
}
$('#bntCloseNews').on('click',function(){
    $('#news-form').hide();
    $('.sticky-email-box').show();
});